import { render } from "./FooterComponent.vue?vue&type=template&id=48ae1694&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=48ae1694&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae1694"]])

export default __exports__